export function IconComponent(){
    return (
        <>

<svg
   width="64"
   height="64"
   viewBox="0 0 847.96814 314.87744"
   version="1.1"

   id="SVGRoot"
   xmlns="http://www.w3.org/2000/svg"
  ><defs
   id="defs1" />
  
 <style
   type="text/css"
   id="style1">

 </style>
 
<rect

   fill="fill:#000000"
   id="rect1"
   width="503.03656"
   height="337.3569"
   x="186.67079"
   y="132.6937" />
  <rect
   fill="#000000"
   id="rect1-87"
   width="43.481552"
   height="67.471413"
   x="414.36575"
   y="469.17776" />
   
   <rect
   fill="#d3d3d3"
   id="rect1-8"
   width="482.04544"
   height="314.86646"
   x="196.2325"
   y="145.8222" />
   
   <ellipse
   fill="#000000"
   
   id="path2"
   cx="347.10272"
   cy="274.75845"
   rx="54.72678"
   ry="59.599712" />
   <ellipse
   fill="#000000"
   id="path2-9"
   cx="530.44086"
   cy="272.1207"
   rx="54.72678"
   ry="59.599712" />
   </svg>

        </>
    )
}